export const LOCATION = 'location';
export const SERVICE = 'service';
export const STAFF = 'staff';
export const TIME = 'time';
export const CONFIRM = 'confirm';
export const TIME_DAY = 'TIME_DAY';
export const TIME_HOURS_AND_MINUTES = 'TIME_HOURS_AND_MINUTES';
export const CREDIT_CARD = 'credit_card';
